<template>
	<div class="map-point-wrapper">
		<div class="point" :style="combinePointStyle(point)" v-for="point in points">
			<div class="location">
				<div class="name" v-html="point.name"></div>
			</div>
			<transition name='pop'>
				<div class="pop" v-html="point.pop_text" v-if="point.pop_text"></div>
			</transition>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		points: {
			type: Array,
			default () {
				return [{
					position: {
						left: '500px',
						top: '60px'
					},
					name: '重庆重庆重庆重庆重庆',
					pop_text: '气泡内容'
				}];
			}
		}
	},
	data() {
		return {}
	},
	mounted() {
	},
	watch: {
		points() {
			this.removePops();
		}
	},
	methods: {
		removePops() {
			clearTimeout(this.popTimeout);
			this.popTimeout = setTimeout(() => {
				for (var i = 0; i < this.$props.points.length; i++) {
					this.$props.points[i].pop_text = undefined;
				}
				clearTimeout(this.popTimeout);
			}, 5000);
		},
		combinePointStyle(point) {
			var position = JSON.parse(JSON.stringify(point.position)),
				zIndex = position.top.replace('px','');
			position['z-index'] = zIndex;
			return position;
		}
	}
}

</script>
<style>
.map-point-wrapper {
	position: absolute;
	top: 0;
	left: 0;
}

.map-point-wrapper .point {
	position: absolute;
	z-index: 1;
	width: 0px;
	height: 0px;
	transition: .5s;
	animation: fadeIn 0.5s forwards;
}

.map-point-wrapper .point .location {
	position: absolute;
	left: 0;
	top: 0;
}

.map-point-wrapper .point .location .name {
	width: 20em;
	position: absolute;
	top: -0.75em;
	left: 10px;
	font-size: 14px;
	font-weight: bold;
	text-shadow: 0 6px 6px rgba(0,0,0,.3);
}

.map-point-wrapper .point .location:before {
	content: '';
	width: 12px;
	height: 12px;
	background: radial-gradient(farthest-corner at 5px 4px,
      #ffff81 0%, #ffc600 60%);
	/*box-shadow: 0 6px 6px rgba(0,0,0,.2),0 0 0 10px rgba(255,198,0,.3);*/
	border-radius: 50%;
	position: absolute;
	left: -6px;
	top: -6px;
	animation: shadow-open 3.4s linear infinite;
}

.map-point-wrapper .point:nth-child(2n) .location:before {
	animation: shadow-open 3.4s linear -1.1s infinite;
}

.map-point-wrapper .point:nth-child(3n) .location:before {
	animation: shadow-open 3.4s linear -2.2s infinite;
}

.map-point-wrapper .point .pop {
	position: absolute;
	bottom: 19px;
	background: rgba(0, 0, 0, .75);
	box-shadow: 0 12px 15px rgba(0,0,0,.5);
	border: 2px solid #ffc600;
	width: 140px;
	left: -71px;
	line-height: 1.5em;
	padding: 10px;
	box-sizing: border-box;
	border-radius: 5px;
	text-align: center;
	z-index: 99;
	font-weight: bold;

	transform-origin: bottom center;
	transition: all cubic-bezier(.4, 1.8, .6, 1) .6s;
}

.map-point-wrapper .point .pop:after {
	content: "";
	position: absolute;
	bottom: -8px;
	left: calc(70px - 7px);
	border-top: 7px solid #ffc600;
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
}

.pop-enter,.pop-leave-to {
	transform: translateY(20px) scale(0);
	opacity: 0;
}

@keyframes fadeIn {
	from {opacity: 0;transform: scale(0);}
	to {opacity: 1;transform: scale(1)}
}

@keyframes shadow-open {
	0% {box-shadow: 0 6px 6px rgba(0,0,0,.2), 0 0 0 0px rgba(255,198,0, 0.4),0 0 0 0px rgba(255,198,0, 0.4);}
	20% {box-shadow: 0 6px 6px rgba(0,0,0,.2), 0 0 0 15px rgba(255,198,0, 0.4),0 0 0 0px rgba(255,198,0, 0.4);}
	40% {box-shadow: 0 6px 6px rgba(0,0,0,.2), 0 0 0 30px rgba(255,198,0, 0),0 0 0 26.7px rgba(255,198,0, 0.134);}
	50% {box-shadow: 0 6px 6px rgba(0,0,0,.2), 0 0 0 30px rgba(255,198,0, 0),0 0 0 40px rgba(255,198,0, 0.0);}
	100% {box-shadow: 0 6px 6px rgba(0,0,0,.2), 0 0 0 30px rgba(255,198,0, 0),0 0 0 40px rgba(255,198,0, 0.0);}
}

</style>



// WEBPACK FOOTER //
// src/components/charts/MapPoint.vue